module.exports = __webpack_public_path__ + "img/f3-1.73bf839a.png";